export default __webpack_public_path__ + "static/media/FANTOMNOMICS.2e4ad649.png";